// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'monSetMyTimezone',
    standalone: false,
})
export class MonSetMyTimezonePipe implements PipeTransform {
    transform (time: any): Date | null {
        if (!time) {
            return null;
        }

        if (!(time instanceof Date)) {
            time = new Date(time);
        }

        const myTimezoneOffset = new Date().getTimezoneOffset() / 60; // Local timezone offset
        const timeInMilliSeconds = time.getTime(); // Time in milliseconds
        const timezoneOffset = time.getTimezoneOffset() / 60; // Server's timezone offset
        const differenceInMilliseconds = (myTimezoneOffset - timezoneOffset) * (1000 * 60 * 60); // Difference in hours

        return new Date(timeInMilliSeconds - differenceInMilliseconds); // Return date stamp
    }
}
